import { Container, Row, Col, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './homeElements'
import { useSelector } from 'react-redux'
import { NextStepValue } from 'utils/type'
import { IHomeNextStepContentProps } from './homeTypes'

interface IHomeStateProps {
  applicationRoles: {
    isConsultant: boolean
  }
}

const NextStepContent = (props: IHomeNextStepContentProps) => {
  const isConsultant: boolean = useSelector(
    (state: IHomeStateProps) =>
      state.applicationRoles && state.applicationRoles.isConsultant
  )

  return props.nextSteps.isFetching ? (
    <Container className="d-flex justify-content-center">
      <Spinner as="span" animation="border" role="status" aria-hidden="true" />
    </Container>
  ) : (
    <Container>
      {props.nextSteps.step === NextStepValue.NONE && (
        <E.BannerButtonLinkParent>
          <E.BannerButtonTitleRow>
            Don’t forget to complete your lease paperwork {props.firstName} – if
            you have already, the team will touch base shortly.
          </E.BannerButtonTitleRow>
          <Row>
            You have completed what’s required here, however if you haven’t done
            so already, please check your email for all the documents which are
            required to be signed and returned to get you behind the wheel of
            the{' '}
            {props.proposalEstimate &&
              props.proposalEstimate.vehicleDescription}
            .
          </Row>
        </E.BannerButtonLinkParent>
      )}
      {props.nextSteps.step === NextStepValue.ATO && (
        <E.BannerButtonLinkParent>
          <Col sm={7}>
            <E.BannerButtonTitleRow>
              It’s time to approve your Authority to Order {props.firstName}!
            </E.BannerButtonTitleRow>
            <Row>
              Hi {props.firstName}, please check and accept your Authority to
              Order. Once you do, we can start getting the{' '}
              {props.proposalEstimate && (
                <span>{props.proposalEstimate.vehicleDescription}</span>
              )}{' '}
              ready for you.
            </Row>
          </Col>
          <E.BannerButtonLinkChild>
            <Link
              to={{ pathname: props.nextSteps.link }}
              target="_blank"
              rel="noopener noreferrer"
              tabIndex={-1}
            >
              <E.BannerPrimaryButton extendInMob disabled={isConsultant}>
                Authority to Order
              </E.BannerPrimaryButton>
            </Link>
            <br />
            <br />
            <Link to={props.viewAcceptedProposal} tabIndex={-1}>
              <E.BannerPrimaryInverted extendInMob invertColor>
                View proposal
              </E.BannerPrimaryInverted>
            </Link>
          </E.BannerButtonLinkChild>
        </E.BannerButtonLinkParent>
      )}
      {props.nextSteps.step === NextStepValue.DEFERRED && (
        <E.BannerButtonLinkParent>
          <Col sm={7}>
            <Row className="font-weight-bold">
              You’re almost there, check back in soon {props.firstName}!
            </Row>
            <Row>
              If you have included add-on insurances in your lease, we will send
              you a separate link to confirm the purchase of these through our
              online portal or you can check back here.
            </Row>
            <Row>
              Don't worry if you don't see this straight away as we are required
              to send you this link at a later day after you have time to
              consider if these insurances are right for you.
            </Row>
          </Col>
          <E.BannerButtonLinkChild>
            <Link
              to={{ pathname: props.nextSteps.link }}
              target="_blank"
              rel="noopener noreferrer"
              tabIndex={-1}
            >
              <E.BannerPrimaryButton disabled>
                Confirm add-on insurances
              </E.BannerPrimaryButton>
            </Link>
            <br />
            <br />
            <Link to={props.viewAcceptedProposal} tabIndex={-1}>
              <E.BannerPrimaryInverted invertColor>
                View proposal
              </E.BannerPrimaryInverted>
            </Link>
          </E.BannerButtonLinkChild>
        </E.BannerButtonLinkParent>
      )}
      {props.nextSteps.step === NextStepValue.INSURANCE && (
        <E.BannerButtonLinkParent>
          <Col sm={7}>
            <E.BannerButtonTitleRow>
              Don’t forget to complete your lease paperwork {props.firstName}–
              if you have already, the team will touch base shortly
            </E.BannerButtonTitleRow>
            <Row>
              You have completed what’s required here, however if you haven’t
              done so already, please check your email for all the documents
              which are required to be signed and returned to get you behind the
              wheel of the {props.proposalEstimate.vehicleDescription}
            </Row>
          </Col>
          <E.BannerButtonLinkChild>
            <Link
              to={{ pathname: props.nextSteps.link }}
              target="_blank"
              rel="noopener noreferrer"
              tabIndex={-1}
            >
              <E.BannerPrimaryButton disabled={isConsultant}>
                Confirm add-on insurances
              </E.BannerPrimaryButton>
            </Link>
            <br />
            <br />
            <Link to={props.viewAcceptedProposal} tabIndex={-1}>
              <E.BannerPrimaryInverted invertColor>
                View proposal
              </E.BannerPrimaryInverted>
            </Link>
          </E.BannerButtonLinkChild>
        </E.BannerButtonLinkParent>
      )}
    </Container>
  )
}
export default NextStepContent
